import { useQuery } from "@tanstack/react-query";
import { SCHEDULE_POLL_MS } from "../../../../shared/config/polling";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";

export const useTechnicianTasks = (
  technicianId: number | string | undefined,
  params: { from: string; to: string },
) => {
  const id = Number(technicianId);
  return useQuery({
    queryKey: taskKeys.technicianTasks(id, params),
    queryFn: () => taskApi.getTechnicianTasks(id, params).then((r) => r.data),
    enabled: Boolean(technicianId) && Boolean(params.from) && Boolean(params.to),
    placeholderData: (prev) => prev,
    refetchInterval: SCHEDULE_POLL_MS,
    refetchIntervalInBackground: false,
  });
};
